// extracted by mini-css-extract-plugin
export default {"CompanyName":"HomeComponent_CompanyName__9wUEw","TheFooter":"HomeComponent_TheFooter__ju5Hu","fth":"HomeComponent_fth__Vp-oe"};